import React from 'react';
import Select from 'react-select';
import classNames from 'classnames';

const MySelect = (props) => {
    return <Select placeholder={'Select option' + (props.isMulti ? 's' : '')} {...props} styles={customStyles} className={classNames({ 'is-invalid': props.isInvalid })} />
}

export default MySelect;

const customStyles = {
    menu: styles => ({ ...styles, zIndex: '2' }),
    control: (base, state) => {
        return {
            ...base, boxShadow: 'none',
            backgroundColor: state.hasValue && !state.isMulti ? '#EBF8FD' : '#FFF',
            border: '1px solid #B3B3B3'
        }
    },
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        const color = '#006188';
        return {
            ...styles,
            backgroundColor: isSelected ? color : isFocused ? '#e4e4e4' : null,
            color: isSelected ? 'white' : isFocused ? '#555555' : null,
            fontSize: '16px',
            ':active': {
                ...styles[':active'],
                color: 'white',
                backgroundColor: !isDisabled ? color : null,
            },
        };
    },
    placeholder: styles => ({ ...styles, color: '#6c757d' }),
    multiValue: styles => ({ 
        ...styles, 
        backgroundColor: '#EBF8FD', 
        padding: '1px', 
        border: '1px solid #006188', 
        fontSize: '16px', 
        margin: '4px 2px',
        borderRadius: '3px'
    }),
    multiValueRemove: (styles, { data }) => ({
        ...styles,
        ':hover': {
            backgroundColor: '#006188',
            color: 'white',
        },
    })
}